const uploadSubmitErrorModalSupport = {
  label: 'Espere a que suban todon los archivos'
};

export default uploadSubmitErrorModalSupport;
